import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { IRegisterRequest } from '~/@api/generated-api-types-user/Api'
import { getErrorMessage } from '~/@lib/utils/error.utils'

export type RegisterRequest = IRegisterRequest

function useRegister() {
  const client = useApiClientUser()

  const registerMutation = useMutation({
    mutationFn: async (props: RegisterRequest) => {
      return await client.user
        .authControllerRegister(props)
        .then(({ data }) => data)
    },
  })

  return {
    registerUserMutation: registerMutation.mutate,
    isRegisterRequesting: registerMutation.isPending,
    error: getErrorMessage(registerMutation.error),
  }
}

export { useRegister }
